import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import ErrorMessage from '../ErrorMessage';
import PhoneInput from 'react-phone-input-2';
import get from 'lodash/get';

import 'react-phone-input-2/lib/style.css';
import useStyles from './PhoneField.styled';
import { countries } from 'constants';

const InputPhone = ({
  field: { name, value },
  disabled,
  form: { setFieldValue, touched, errors },
  label,
  placeholder,
  asyncErrors,
  rawname,
  dialcodename,
  disableDropdown,
  required,
}) => {
  const classes = useStyles();
  return (
    <Box className={classes.root}>
      {label && (
        <label className={classes.label} htmlFor={name}>
          {label}
          {required ? (
            <span aria-hidden="true" class="MuiFormLabel-asterisk MuiInputLabel-asterisk">
               *
            </span>
          ) : null}
        </label>
      )}
      <>
        <PhoneInput
          value={value}
          country={'us'}
          inputProps={{ name }}
          disabled={disabled}
          disableDropdown={disableDropdown}
          countryCodeEditable={false}
          placeholder={placeholder}
          onlyCountries={countries?.map((c) => c?.value?.toLowerCase())}
          onChange={(phone, country) => {
            setFieldValue(name, `+${phone}`);
            if (rawname && phone) {
              setFieldValue(rawname, phone.slice(country.dialCode.length));
            }
            if (dialcodename && phone) {
              setFieldValue(dialcodename, country.dialCode);
            }
          }}
        />
      </>
      {(get(touched, name, false) && get(errors, name, false)) || asyncErrors ? (
        <ErrorMessage hasIcon={false} className={classes.errorMsg}>
          {get(errors, name, '') || asyncErrors}
        </ErrorMessage>
      ) : null}
    </Box>
  );
};

InputPhone.propTypes = {
  label: PropTypes.string,
  field: PropTypes.shape({
    value: PropTypes.any,
    name: PropTypes.string,
    onChange: PropTypes.func,
  }),
  form: PropTypes.shape({
    errors: PropTypes.object,
    touched: PropTypes.object,
    setFieldValue: PropTypes.func,
  }),
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  disableDropdown: PropTypes.bool,
};

InputPhone.defaultProps = {
  disabled: false,
  disableDropdown: true,
  label: '',
  form: {},
  field: {},
  placeholder: '',
};

export default InputPhone;
